import { Umfuhr, Umfuhrpos } from '@/modules/ewwms/models/Lager/UmfuhrModels';

export type State = {
  umfuhren: Array<Umfuhr>;
  umfuhrpos: Array<Umfuhrpos>;
};

export const state: State = {
  umfuhren: sessionStorage.getItem('umfuhren') != null ? JSON.parse(sessionStorage.umfuhren) : new Array<Umfuhr>(),
  umfuhrpos: sessionStorage.getItem('umfuhrpos') != null ? JSON.parse(sessionStorage.umfuhrpos) : new Array<Umfuhrpos>(),
};
